import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '../../../../../../../../components/Button/Button'
import { Agenda, AgendaItemStatus } from '../../../../../../../../models/Agenda'
import { ProgressCircle } from '../../../../../../../../components/ProgressCircle/ProgressCircle'
import { ReactComponent as CompletedIcon } from '../../../../../../../../assets/images/agenda-item-status-completed.svg'
import { ReactComponent as OpenIcon } from '../../../../../../../../assets/images/agenda-item-status-open.svg'

interface AgendaModalProps {
  show: boolean
  onHide: () => void
  agenda: Agenda
}

export const AgendaModal: React.FC<AgendaModalProps> = ({ show, onHide, agenda }) => {
  const completedItems = agenda.items.filter((item) => item.status === AgendaItemStatus.Completed)
  const openItems = agenda.items.filter((item) => item.status === AgendaItemStatus.Open)

  const completionPercentage = Math.round((completedItems.length / agenda.items.length) * 100)

  return (
    <Modal show={show} onHide={onHide} size='lg' centered>
      <Modal.Header className='border-bottom border-gray-300 px-4 py-3'>
        <Modal.Title className='fw-bold h4'>Review Meeting Agenda</Modal.Title>
        <button type='button' className='btn-close' onClick={onHide} aria-label='Close' />
      </Modal.Header>

      <Modal.Body className='p-4'>
        <div className='d-flex flex-column gap-4'>
          {agenda.items.length > 0 ? (
            <div className='border border-gray-300 rounded p-2'>
              <div className='zocks-bg-color-gray-100 border border-gray-200 rounded d-flex align-items-center gap-4 px-4 py-2'>
                <ProgressCircle percentage={completionPercentage} size={48} />
                <p className='mb-0 flex-grow-1 paragraph-medium'>
                  <span className='fw-bold text-gray-900'>
                    Great job covering {completedItems.length} of {agenda.items.length} agenda items!
                  </span>{' '}
                  {openItems.length > 0 ? (
                    <span className='fw-medium text-gray-900'>
                      The remaining {openItems.length === 1 ? 'topic' : 'topics'} {openItems.length === 1 ? 'is' : 'are'} now in your task list.
                    </span>
                  ) : null}
                </p>
              </div>
            </div>
          ) : null}

          <div className='d-flex flex-column gap-4'>
            {completedItems.length > 0 ? (
              <div className='d-flex flex-column gap-3'>
                {completedItems.map((item) => (
                  <div key={item.id} className='d-flex align-items-center gap-3 rounded'>
                    <CompletedIcon />
                    <p className='flex-grow-1 mb-0 text-decoration-line-through text-gray-700 fw-medium paragraph-medium-extended'>{item.text}</p>
                  </div>
                ))}
              </div>
            ) : null}

            {openItems.length > 0 ? (
              <div className='d-flex flex-column gap-3'>
                {openItems.map((item) => (
                  <div key={item.id} className='d-flex align-items-center gap-3 rounded'>
                    <OpenIcon />
                    <p className='flex-grow-1 mb-0 fw-medium text-gray-900 paragraph-medium-extended'>{item.text}</p>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className='d-flex justify-content-end gap-3 p-4'>
        <Button variant='secondary' onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
